import { render } from "./AutoWithdrawalSettingsModal.vue?vue&type=template&id=10ed5a8e&ts=true"
import script from "./AutoWithdrawalSettingsModal.vue?vue&type=script&lang=ts"
export * from "./AutoWithdrawalSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__